import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDeDfHA_Hqk-YdFRKvuP60MBWFLdHL1siI",
  authDomain: "faissalsaaf-3dde0.firebaseapp.com",
  projectId: "faissalsaaf-3dde0",
  storageBucket: "faissalsaaf-3dde0.firebasestorage.app",
  messagingSenderId: "125049893006",
  appId: "1:125049893006:web:8d50a0c47425f0ac1059df",
  measurementId: "G-XHQ55RE4WV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

export default app;